import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const STEP_FALLBACKS = [
  'Fill in your information and submit to get started.',
  'An expert will call you within 2 hours to understand your needs.',
  "Share the required documents — we'll guide you on what's needed.",
  'Our experts prepare and file your request.',
  "It's completed quickly and you'll receive confirmation.",
];

/** Compact numbered stepper — a small "how it works" strip, reused across service pages. */
const QuickProcessSteps = ({ className = '' }) => {
  const { t } = useLanguage();
  return (
    <div className={className}>
      <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-[#14A098] mb-4">
        {t('sf.quick_process', 'Quick Process')}
      </p>
      <div className="flex flex-wrap items-start justify-between gap-x-2 gap-y-6 max-w-5xl mx-auto">
        {STEP_FALLBACKS.map((fallback, idx) => (
          <React.Fragment key={idx}>
            <div className="flex flex-col items-center text-center w-24 sm:w-28 md:w-32">
              <span className="w-7 h-7 rounded-full bg-[#14A098] text-white text-xs font-bold flex items-center justify-center mb-2 shrink-0">
                {idx + 1}
              </span>
              <span className="text-[11px] sm:text-xs text-gray-500 leading-snug">
                {t(`sf.quick_process_step${idx + 1}`, fallback)}
              </span>
            </div>
            {idx < STEP_FALLBACKS.length - 1 && (
              <div className="hidden sm:block flex-1 min-w-[16px] h-px bg-gray-300 mt-3.5" aria-hidden />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default QuickProcessSteps;
